// src/utils/heartbeat.js
// Gera payloads de heartbeat/closed e expõe os IDs (browserId, tabId)

function makeUuid() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function getOrCreateBrowserId() {
  let id = localStorage.getItem('lf_browser_id');
  if (!id) {
    id = makeUuid();
    localStorage.setItem('lf_browser_id', id);
  }
  return id;
}

function getOrCreateTabId() {
  let id = sessionStorage.getItem('lf_tab_id');
  if (!id) {
    id = makeUuid();
    sessionStorage.setItem('lf_tab_id', id);
  }
  return id;
}

function defaultVersion() {
  try { return (import.meta?.env?.VITE_APP_VERSION ?? 'dev'); }
  catch { return 'dev'; }
}

function baseData(userId, opts = {}) {
  const versionResolver = opts.versionResolver || defaultVersion;
  return {
    userId,
    browserId: getOrCreateBrowserId(),
    tabId: getOrCreateTabId(),
    appVersion: versionResolver(),
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    language: navigator.language,
    screen: `${window.screen?.width || 0}x${window.screen?.height || 0}`,
    // Permite sobrescrever rota/visibilidade se quiser
    route: opts.route ?? (window.location.pathname + window.location.search),
    visibility: opts.visibility ?? document.visibilityState
  };
}

/**
 * Retorna o payload para “alive”.
 * @param {number|string} userId
 * @param {{route?: string, visibility?: string, versionResolver?: ()=>string}} [opts]
 */
export function heartbeatData(userId, opts = {}) {
  return { ...baseData(userId, opts), status: 'alive' };
}

/**
 * Retorna o payload para “closed”.
 * Útil em beforeunload/pagehide.
 * @param {number|string} userId
 * @param {{route?: string, visibility?: string, versionResolver?: ()=>string}} [opts]
 */
export function closedPayload(userId, opts = {}) {
  return { ...baseData(userId, opts), status: 'closed' };
}

/**
 * Retorna apenas os IDs gerados/persistidos.
 */
export function getInstanceIds() {
  return {
    browserId: getOrCreateBrowserId(),
    tabId: getOrCreateTabId()
  };
}
